/**
 * Created by shanie on 1/13/17.
 */
import React from 'react';
import PropTypes from 'prop-types';

// Components
import ClearSearchIcon from 'dibs-vg/dist/react/close';
import SearchIcon from 'dibs-vg/dist/react/magnifying-glass';

import { updateSearchParams } from '../../helpers/urlHelpers';

// Styles
import styles from './styles/SearchBar.scss';

// Tracking
import { trackEvent } from 'dibs-tracking';

class SearchBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: props.searchTerm,
        };

        this.clearSearch = this.clearSearch.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.search = this.search.bind(this);
    }

    componentWillReceiveProps(nextProps, props) {
        if (nextProps.searchTerm === '' && props.searchTerm !== '') {
            this.setState({
                searchTerm: '',
            });
        }
    }

    clearSearch() {
        this.props.onSearch('');
    }

    onKeyPress(event) {
        if (event.key === 'Enter') {
            this.search();
        }
    }

    onTextChange(event) {
        if (event.target.value === '' && this.props.searchTerm !== '') {
            updateSearchParams('search', event.target.value);
            this.clearSearch();
        } else {
            this.setState({
                searchTerm: event.target.value,
            });
        }
    }

    search() {
        updateSearchParams('search', this.state.searchTerm);

        if (this.state.searchTerm !== '') {
            trackEvent({
                action: 'search within favorites',
                label: 'none',
                category: 'favorites',
            });
            this.props.onSearch(this.state.searchTerm);
        }
    }

    render() {
        let icon = <SearchIcon />;
        let onClick = this.search;
        if (this.state.searchTerm === this.props.searchTerm && this.state.searchTerm !== '') {
            icon = <ClearSearchIcon className={styles.close} />;
            onClick = this.clearSearch;
        }

        return (
            <div className={styles.container}>
                <input
                    data-tn="favorites-search"
                    type="text"
                    name="search"
                    className={styles.input}
                    placeholder="Search items"
                    onChange={this.onTextChange}
                    onKeyPress={this.onKeyPress}
                    value={this.state.searchTerm}
                />
                <div className={styles.searchButton}>
                    <button
                        type="submit"
                        className={styles.searchButton}
                        data-tn="favorites-search-button"
                        onClick={onClick}
                    >
                        {icon}
                    </button>
                </div>
            </div>
        );
    }
}

SearchBar.propTypes = {
    onSearch: PropTypes.func,
    searchTerm: PropTypes.string,
};

export default SearchBar;
